import { createSlice } from '@reduxjs/toolkit';
import { calculateSiteIDMapping } from '../../lib';
import { resetApplication } from '../application/slice';
import locationsState from './state';
export const locationsSlice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => locationsState);
    },
    initialState: locationsState,
    name: 'locations',
    reducers: {
        errorReceiveLocations: state => {
            state.locations = undefined;
            state.requestingLocations = false;
        },
        failedReceiveLocations: state => {
            state.locations = undefined;
            state.requestingLocations = false;
        },
        receiveLocations: {
            prepare: locations => {
                return {
                    payload: {
                        locations
                    }
                };
            },
            reducer: (state, action) => {
                const { locations } = action.payload;
                state.locations = locations;
                state.requestingLocations = false;
            }
        },
        requestLocations: {
            prepare: (consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI
                    }
                };
            },
            reducer: state => {
                state.requestingLocations = true;
            }
        },
        resetLocations: () => locationsState,
        setSiteIDMapping: {
            prepare: locations => {
                return {
                    payload: {
                        locations
                    }
                };
            },
            reducer: (state, action) => {
                const { locations } = action.payload;
                state.siteSlugs = calculateSiteIDMapping(locations);
            }
        }
    }
});
export const { errorReceiveLocations, failedReceiveLocations, receiveLocations, requestLocations, resetLocations, setSiteIDMapping } = locationsSlice.actions;
export default locationsSlice.reducer;
